<template>
  <div class="row mt-2 ms-1 me-1" v-for="part in parts" :key="part.id">
    <section-header
      >Co to jest <span class="text-primary">{{ part.name }}</span
      >?</section-header
    >
    <p v-html="part.definition" class="part list-p-margin"></p>
  </div>
</template>
<script>
import SectionHeader from "@/components/fault-detail-components/SectionHeader";
export default {
  components: { SectionHeader },
  props: {
    parts: [],
  },
};
</script>
<style scoped>
.part {
  padding: 8px 8px 8px 12px;
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
}
</style>
